import {useEffect, useState} from 'react'

import {useDetectInputDevices} from './useDetectInputDevices'

export interface SoftwareKeyboardAwareViewport {
  reducedViewportHeight?: number
}

const minimumHeightToAssumePresenceOfKeyboard = 100 // this can't be zero because sometimes there are floating toolbar or other native chrome that reduce the visualViewport's height. but we don't want to adjust for those because 1. we're only trying to adapt the layout for an actual keyboard and 2. we don't need to do anything differently if the viewport height is only a little shorter. it's just when it's a lot shorter that our UI gets cramped and we need to drastically change how something is laid out.

export function useSoftwareKeyboardAwareViewport() {
  const {hasTouch} = useDetectInputDevices()
  const [state, setState] = useState<SoftwareKeyboardAwareViewport>({})

  useEffect(() => {
    function handleResize() {
      if (!hasTouch) {
        return
      }

      const vvHeight = window.visualViewport?.height
      if (!vvHeight) {
        return
      }

      const softwareKeyboardProbablyActive =
        window.document.body.clientHeight - vvHeight > minimumHeightToAssumePresenceOfKeyboard

      setState({
        reducedViewportHeight: softwareKeyboardProbablyActive ? vvHeight : undefined
      })
    }

    window.visualViewport?.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.visualViewport?.removeEventListener('resize', handleResize)
    }
  }, [hasTouch, setState])

  return state
}
